import { MsdynamicsUserMapping } from "../schema/dynamics";

/**
 * The owner privileges to warn about on one user-mapping row, or `null` for no warning
 * (PREC-4361). The check belongs to the Dynamics user that is saved: once the row is switched to
 * another Dynamics user and not yet saved, the old answer no longer describes it.
 */
export function dynamicsOwnerPrivilegeWarning(
	savedMappings: Pick<
		MsdynamicsUserMapping,
		"userId" | "msdynamicsOwnerId" | "missingPrivileges"
	>[],
	userId: number,
	selectedOwnerId: string | undefined
): string[] | null {
	const saved = savedMappings.find((mapping) => mapping.userId === userId);

	if (!saved || !selectedOwnerId || saved.msdynamicsOwnerId !== selectedOwnerId) {
		return null;
	}

	return saved.missingPrivileges?.length ? saved.missingPrivileges : null;
}
